import { CoauthorInformation } from './CoauthorInformation';
import { PersonaInfo } from '../../../controls/AppPersonaButton';

/**
 * Coauthor Gallery only has space for a certain amount of coins in the Facepile. If there are more coauthors than the max
 * amount allowed, we need to reduce the allowed amount of coins we pass by 1 in order to reserve space for the overflow button.
 */
export const getFacepileCoauthorCount = (maxFacepileCoauthors: number, numOfCoauthors: number): number => {
  const numCoauthorsWithOverflow = Math.max(maxFacepileCoauthors - 1, 0);
  return numOfCoauthors > maxFacepileCoauthors ? numCoauthorsWithOverflow : maxFacepileCoauthors;
};

/**
 * Sort all coauthors into an array first by if you can interact with them (indicated by the presence of a ring),
 * then by either alphabetically or join time
 * @param coauthors The list of coauthors that needs to be sorted.
 * @param sortByJoinTime Should the function sort by join time instead of by name
 */
export const sortCoauthors = (coauthors: CoauthorInformation[], sortByJoinTime?: boolean): CoauthorInformation[] => {
  return coauthors.slice(0).sort((a: CoauthorInformation, b: CoauthorInformation) => {
    const aHasRing = !!a.hasRing;
    const bHasRing = !!b.hasRing;
    const aKey = (sortByJoinTime ? a.joinTime : a.name) || -1;
    const bKey = (sortByJoinTime ? b.joinTime : b.name) || -1;
    if (aHasRing === bHasRing) {
      if (sortByJoinTime) {
        return aKey > bKey ? -1 : aKey < bKey ? 1 : 0;
      }
      return aKey < bKey ? -1 : aKey > bKey ? 1 : 0;
    }
    return aHasRing > bHasRing ? -1 : 1;
  });
};

export const convertCoauthorInfoToPersonaInfo = (coauthorInfo: CoauthorInformation): PersonaInfo => {
  return {
    displayName: coauthorInfo.name,
    identifiers: {
      PersonaType: 'User',
      Smtp: coauthorInfo.upn,
    },
    personaCoinColor: coauthorInfo.color,
  };
};
